import axios from "axios";

import { wpDomainApi, ttmDomainApi } from "../../app/configs/wp.config";

const version = "v1";
const versionTTM = "v2";

const wpApi = axios.create({
  baseURL: `${wpDomainApi}/api/${version}`,
  headers: { "X-Requested-With": "XMLHttpRequest" },
  withCredentials: true,
});

const ttmApi = axios.create({
  baseURL: `${ttmDomainApi}/wp-json/wp/${versionTTM}`,
  headers: { "X-Requested-With": "XMLHttpRequest" },
  withCredentials: true,
});

export const getNowCasting = async () => {
  const res = await wpApi.get("/weather/map/nowcasting");

  return res.data;
};

export const getNowCasting10Minutes = async ({ lat, lng }) => {
  const res = await wpApi.get("/weather/map/nowcasting-10minutes", {
    params: {
      lat,
      lng,
    },
  });

  return res.data;
};

export const getWeatherOnMap = async (bound, zoom) => {
  const res = await wpApi.post("/weather/map", { bound, zoom });
  return res.data;
};

export const getWeatherHistory = async (locations) => {
  const res = await wpApi.post("/weather/history", { locations });
  return res.data;
};

export const getCurrentWeather = async (location) => {
  const res = await wpApi.get("/weather/now", { params: { ...location } });

  return res.data;
};

export const getCurrentAQI = async (location) => {
  const res = await wpApi.get("/weather/now/aqi", { params: { ...location } });

  return res.data;
};

export const getCurrentUVD = async (location) => {
  const res = await wpApi.get("/weather/now/uvd", { params: { ...location } });

  return res.data;
};

export const getTodayWeather = async (location) => {
  const res = await wpApi.get("/weather/today", { params: { ...location } });

  return res.data;
};

export const getNextHoursWeather = async (location) => {
  const res = await wpApi.get("/weather/hour/24", { params: { ...location } });

  return res.data;
};

export const getNextDaysWeather = async (location) => {
  const res = await wpApi.get("/weather/day/15", { params: { ...location } });

  return res.data;
};

export const get90DaysWeather = async (location) => {
  const res = await wpApi.get("/weather/day/90", { params: { ...location } });

  return res.data;
};

export const getNewsCategories = async (language) => {
  const res = await wpApi.get("/post/category", { params: { language } });

  return res.data;
};

// export const getRecentNews = async (language) => {
//   const res = await wpApi.get("/post/recent", { params: { language } });

//   return res.data;
// };
export const getRecentNews = async (language) => {
  const res = await ttmApi.get("/posts", { params: { per_page: 5, orderby: 'date', order: 'desc', _embed: true } });
  var result = res.data.map(
    (el) => {
      return {
        id: el.id,
        type: "NORMAL",
        photo: el._embedded["wp:featuredmedia"][0].source_url,
        card: el._embedded["wp:featuredmedia"][0].source_url,
        thumbnail: el._embedded["wp:featuredmedia"][0].source_url,
        state: el.status == "publish" ? "PUBLISHED" : "",
        publishedAt: el.modified,
        data: [
          {
            id: el.id,
            language: "VI",
            postId: el.id,
            title: el.title.rendered,
            url: el.link,
            description: "",
            content: el.content.rendered,
            createdAt: el.date,
            updatedAt: el.modified
          }
        ],
        tags: [
          {
            id: 21,
            type: "CATEGORY",
            data: [
              // {
              //   id: 43,
              //   tagId: 21,
              //   language: "EN",
              //   name: "recruitment",
              //   url: "recruitment",
              //   description: "Recruitment",
              //   createdAt: "2024-04-05T02:54:08.000Z",
              //   updatedAt: "2024-04-05T02:54:08.000Z"
              // },
              {
                // id: 44,
                // tagId: 21,
                language: "VI",
                name: el._embedded["wp:term"][0][0].name,
                url: el._embedded["wp:term"][0][0].slug,
                // description: "Tin tuyển dụng",
                // createdAt: "2024-04-05T02:54:08.000Z",
                // updatedAt: "2024-04-05T02:54:08.000Z"
              }
            ]
          }
        ]
      }
    }
  )

  return result;
};
export const getStormNews = async (language) => {
  const params = { url: "tin-bao", language };
  const res = await wpApi.get("/post", { params });

  return res.data
}

export const getNews = async (url, language, page) => {
  const params = { url, language };
  if (page) params.page = page;

  const res = await wpApi.get("/post", { params });

  return res.data;
};

export const getMostViewNews = async (language, page) => {
  const params = { url: "khi-hau-viet-nam", language };
  const res = await wpApi.get("/post", { params })

  return res.data;
}

export const listNews = async (tagId, page, limit, language) => {
  const res = await wpApi.get("/post/list", {
    params: { tagId, page, limit, language },
  });

  return res.data;
};

export const getSmartGenData = async ({ lat, lng }) => {
  const res = await wpApi.get("/weather/smartgen", {
    params: { lat, lng },
  });

  return res.data;
};

export const getSolutionsData = async () => {
  const res = await wpApi.get("/solution");

  return res.data;
};
export const getSolutionsDataDetail = async ({ id }) => {
  const res = await wpApi.get("/solution/detail", { params: { id } });

  return res.data
}
export default {
  getWeatherOnMap,
  getWeatherHistory,
  getCurrentWeather,
  getCurrentAQI,
  getCurrentUVD,
  getTodayWeather,
  getNextHoursWeather,
  getNextDaysWeather,
  get90DaysWeather,
  getNewsCategories,
  getRecentNews,
  getNews,
  listNews,
  getSmartGenData,
  getSolutionsData,
  getSolutionsDataDetail,
  getNowCasting10Minutes,
  getStormNews,
  getMostViewNews
};
